'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import Link from 'next/link';

export default function NotFound() {
    const router = useRouter();

    const handleGoBack = () => {
        if (typeof window !== 'undefined') {
            window.history?.back();
        }
    };

    return (
        <div
            className="min-h-screen flex flex-col items-center justify-center p-4"
            style={{ background: '#ffffff' }}
        >
            <div className="text-center max-w-md">
                {/* Large 404 - Pinnacle1 style: thin Poppins */}
                <div className="flex justify-center mb-6">
                    <h1
                        style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontSize: '160px',
                            fontWeight: 100,
                            color: '#00A7FF',
                            opacity: 0.2,
                            lineHeight: 1,
                        }}
                    >
                        404
                    </h1>
                </div>

                <div style={{ width: '48px', height: '3px', background: '#00A7FF', margin: '0 auto 24px' }}></div>

                <h2
                    className="mb-2"
                    style={{ fontFamily: 'Poppins, sans-serif', fontSize: '28px', fontWeight: 400, color: 'rgba(0,0,0,0.8)' }}
                >
                    Page Not Found
                </h2>
                <p
                    className="mb-8"
                    style={{ fontFamily: 'Poppins, sans-serif', fontSize: '16px', color: '#48494B', lineHeight: 1.7 }}
                >
                    The page you&apos;re looking for doesn&apos;t exist. Let&apos;s get you back!
                </p>

                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <button
                        onClick={handleGoBack}
                        className="inline-flex items-center justify-center gap-2 px-6 py-3 font-semibold transition-all duration-200 hover:opacity-90"
                        style={{ background: '#00A7FF', color: '#ffffff', fontFamily: 'Montserrat, sans-serif', fontSize: '14px' }}
                    >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                        </svg>
                        Go Back
                    </button>

                    <Link
                        href="/"
                        className="inline-flex items-center justify-center gap-2 px-6 py-3 font-semibold transition-all duration-200"
                        style={{
                            border: '2px solid #00A7FF',
                            color: '#00A7FF',
                            fontFamily: 'Montserrat, sans-serif',
                            fontSize: '14px',
                        }}
                        onMouseEnter={(e) => {
                            (e.currentTarget as HTMLElement).style.background = '#00A7FF';
                            (e.currentTarget as HTMLElement).style.color = '#ffffff';
                        }}
                        onMouseLeave={(e) => {
                            (e.currentTarget as HTMLElement).style.background = 'transparent';
                            (e.currentTarget as HTMLElement).style.color = '#00A7FF';
                        }}
                    >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                        </svg>
                        Back to Home
                    </Link>
                </div>
            </div>
        </div>
    );
}